export { default } from './ClinicInformation.container';


// WEBPACK FOOTER //
// ./src/components/ClinicInformation/index.ts